import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { getIsAbTest } from 'ContentEditorUI/redux/selectors/abTestSelectors';
// @ts-expect-error dependency missing types
import { getIsMABExperiment } from 'ContentEditorUI/redux/selectors/mabExperimentSelectors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { withApprovalContext } from 'ui-product-approvals/hoc/withApprovalContext';
import { getIsEmail } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const ShowMeButton = ({
  children,
  onClick
}) => {
  return /*#__PURE__*/_jsx(Button, {
    use: "link",
    onClick: onClick,
    children: children
  });
};
const TestVariationAlertContent = ({
  approval
}) => {
  const isAbTest = useSelector(getIsAbTest);
  const isAdaptiveTest = useSelector(getIsMABExperiment);
  const isEmail = useSelector(getIsEmail);
  const [isVisible, setIsVisible] = useState(true);
  const dispatch = useDispatch();
  if (!isVisible || !isAbTest && !isAdaptiveTest) {
    return null;
  }
  const titleText = /*#__PURE__*/_jsx(FormattedMessage, {
    message: `approvals.testVariationAlert.title.${isAbTest ? 'ab' : 'adaptive'}`
  });
  const onShowMeClick = () => {
    dispatch({
      type: 'SHOW_APPROVALS_TEST_VARIATIONS_TOUR'
    });
    if (approval.meta.showModal) {
      approval.meta.setShowModal(false);
    }
  };
  return /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "500",
    children: /*#__PURE__*/_jsx(Alert, {
      type: "tip",
      titleText: titleText,
      closeable: true,
      onClose: () => setIsVisible(false),
      children: isEmail ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "approvals.testVariationAlert.messageWithoutShowMe"
      }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "approvals.testVariationAlert.message_jsx",
        elements: {
          ShowMeButton
        },
        options: {
          onClick: onShowMeClick
        }
      })
    })
  });
};
export default withApprovalContext(TestVariationAlertContent);